import { InputAdornment } from '@mui/material';
import { BenefitDTOBenefitEnum, CreateBenefitActivationDTO, UpdateBenefitActivationDTO } from 'probonio-shared-ui/api';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextFieldControl } from '../../../../component/form';
import { BenefitActivationDialogExtensionInterface } from '../../../../extension/interface/benefit-activation-dialog.extension.interface';
import { ActivationDialogExtensions } from '../../ActivationDialog';

interface KitaBenefitOptions {
  monthlyBudget: number;
}

const InlineField: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  const { control } = useFormContext();

  return (
    <TextFieldControl
      slotProps={{ input: { endAdornment: <InputAdornment position="end">€</InputAdornment> } }}
      rules={{
        required: true,
        min: 5,
        max: 1000,
      }}
      type="number"
      control={control}
      variant="outlined"
      name="benefitOptions.monthlyBudget"
      label={t('KITA.fields.monthlyBudget')}
      margin="dense"
      fullWidth
    />
  );
};

const resetKitaBenefitOptions: ActivationDialogExtensions<KitaBenefitOptions>['onResetBenefitOptions'] = (
  selectedActivation,
): KitaBenefitOptions => {
  return {
    monthlyBudget: selectedActivation?.kitaOptions ? selectedActivation.kitaOptions.monthlyBudget / 100 : 50,
  };
};

const mapKitaOptions = (benefitOptions: KitaBenefitOptions) => ({
  monthlyBudget: Math.round(benefitOptions.monthlyBudget * 100),
});

const createKitaBenefitActivation: ActivationDialogExtensions<KitaBenefitOptions>['onCreateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const create: CreateBenefitActivationDTO = {
    ...baseValues,
    benefit: BenefitDTOBenefitEnum.Kita,
    kitaOptions: mapKitaOptions(benefitOptions),
  };
  await saveActivation(create);
};

const updateKitaBenefitActivation: ActivationDialogExtensions<KitaBenefitOptions>['onUpdateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const update: UpdateBenefitActivationDTO = {
    ...baseValues,
    kitaOptions: mapKitaOptions(benefitOptions),
  };
  await saveActivation(update);
};

export class KitaBenefitActivationDialogExtension extends BenefitActivationDialogExtensionInterface<KitaBenefitOptions> {
  InlineField?: React.ComponentType = InlineField;

  onCreateActivation = createKitaBenefitActivation;
  onUpdateActivation = updateKitaBenefitActivation;
  onResetBenefitOptions? = resetKitaBenefitOptions;
}
